import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { userApi } from '../../api/userApi';

const AuthLayout = ({ children }) => {
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await userApi.getLoginImages();
        const imageUrls = response.map(item => item.image);
        setImages(imageUrls);
      } catch (error) {
        console.error('Failed to fetch login images:', error);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="min-h-screen bg-white flex">
      {/* Brand Section */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Carousel Images */}
        {images.map((image, index) => (
          <motion.div
            key={index}
            className="absolute inset-0"
            initial={{ opacity: 0 }}
            animate={{ 
              opacity: currentImageIndex === index ? 1 : 0,
              scale: currentImageIndex === index ? 1 : 1.1
            }}
            transition={{ 
              opacity: { duration: 1 },
              scale: { duration: 6 }
            }}
          >
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-6000"
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
          </motion.div>
        ))}

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Carousel Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
          {images.map((_, index) => (
            <motion.div
              key={index}
              className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                currentImageIndex === index ? 'w-6 bg-white' : 'w-1.5 bg-white/50'
              }`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>

        {/* Content Container */}
        <div className="relative w-[500px] h-[300px] flex items-center justify-center m-auto z-10">
          {/* Decorative Frame */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="absolute inset-0"
          >
            {/* Top Left Corner */}
            <div className="absolute top-0 left-0">
              <div className="w-24 h-[2px] bg-white"></div>
              <div className="w-[2px] h-24 bg-white"></div>
            </div>

            {/* Bottom Right Corner */}
            <div className="absolute bottom-0 right-0">
              <div className="w-24 h-[2px] bg-white"></div>
              <div className="w-[2px] h-24 bg-white absolute bottom-0 right-0"></div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-center z-10 px-16"
          >
            <h1 className="text-5xl font-bold text-white mb-6 drop-shadow-lg">
              Panchali Design Hub
            </h1>
            <div className="w-24 h-[2px] bg-white mx-auto mb-6"></div>
            <p className="text-gray-100 text-lg drop-shadow-lg">
              Where Luxury Meets Tradition
            </p>
          </motion.div>
        </div>
      </div>
      
      {/* Form Section */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default AuthLayout;










